module.exports = __webpack_public_path__ + "img/restaurant-6.9dda8c89.jpg";